import WorkflowService from '~/scripts/services/workflow.service';

/**
 * @param {import('angular').auto.IInjectorService} $injector
 * @param {any} $scope
 * @param {import('angular').ITimeoutService} $timeout
 */
export default /* @ngInject */ (
	$injector,
	$scope,
	$timeout,
) => {
	const workflowService = new WorkflowService($injector);

	$scope.options = {
		checkBox:     false,
		history:      $scope.component.displayHistoryBtn,
		id:           'close',
		openWf:       false,
		showAdd:      false,
		subscription: false,
	};

	if ($scope.form?.kid) {
		$timeout(async () => {
			$scope.affectList = await workflowService.nodeAffectList($scope.form.kid, $scope.options.id);
			$scope.$apply();
		});
	}
};
